import React from "react";
import ContactUs from "../components/Contact/ContactUs";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const Contact = () => {
  return (
    <div>
      <Header />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Contact;
